const PostBticino = (data, cb) => {
  fetch(`${process.env.REACT_APP_API}/datahome`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Agent-Header": "bticino",
    },
    //   body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((json) => cb(null, json))
    .catch((err) => cb(err, null));
};

export default PostBticino;
